import { Routes } from '@angular/router';
import { loginRoutes } from './components/login/login-routing.module';
import { monitorRoutes } from './components/monitor/monitor-routing.module';
import { monitorOverviewRoutes } from './components/monitor-overview/monitor-overview-routing.module';
import { monitorAlarmTabletRoutes } from './components/monitor-alarmtablet/monitor-alarmtablet-routing.module';

export const appRoutes: Routes = [
  // Login routes
  ...loginRoutes,

  // Monitor routes
  ...monitorRoutes,

  // Monitor Overview routes
  ...monitorOverviewRoutes,

  // Alarm Tablet routes
  ...monitorAlarmTabletRoutes,

  // Wildcard route - must be last
  {
    path: 'not-found',
    loadComponent: () => import('./components/not-found/not-found.component').then(m => m.NotFoundComponent)
  },
  {
    path: '**',
    loadComponent: () => import('./components/not-found/not-found.component').then(m => m.NotFoundComponent)
  }
];
